// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_fp-0";
export var fileCarousel = "_fp-2";
export var removeFileButton = "_fp-1";